import { checkInBaggage } from '@eti/products';
import type { PreSelectedProductItem } from '../model';
import PreSelectedProduct from './PreSelectedProduct';

interface PreSelectedProductsListProps {
  preSelectedExtraProducts: PreSelectedProductItem[];
  commonProductsInFare?: number[];
  productsHandler: (productId: number) => void;
  removedProductsId: number[];
}

const PreSelectedProductsList = ({
  preSelectedExtraProducts,
  commonProductsInFare,
  productsHandler,
  removedProductsId,
}: PreSelectedProductsListProps) => {
  const preSelectedProducts = preSelectedExtraProducts?.map((product: PreSelectedProductItem) => {
    const { productId, name, price } = product;
    const isRemoved = removedProductsId.includes(productId);
    const isCheckedInBaggageAvailableInFare =
      commonProductsInFare?.includes(productId) && productId === checkInBaggage.id && isRemoved;
    return (
      <PreSelectedProduct
        isCheckedInBaggageAvailableInFare={Boolean(isCheckedInBaggageAvailableInFare)}
        isRemoved={isRemoved}
        key={productId}
        name={name}
        price={price}
        productId={productId}
        productsHandler={productsHandler}
      />
    );
  });

  return <>{preSelectedProducts}</> || null;
};

export default PreSelectedProductsList;
